import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-reporting }}\n{{yield this.width}}",{ moduleName: "embercom/components/reporting/element/container-width.hbs" })